/* eslint-disable @typescript-eslint/no-explicit-any */
import { hall } from '../hall'
import { ModuleBase } from './ModuleBase'

//应该是网络这边发送你有跑马灯了，才会去展示这些内容
export class MarqueeModule extends ModuleBase {
  public turnNum: number = 0 //当前展示的节点
  public turnList: any[] = []

  public jackGameList: any[] = []
  public isStart = false //是否已经启动开始跑马灯（跑马灯现在会一直启动）
  public timePanel: any = null

  init(): void {
    this.initTurnList()
    this.turnNum = 0
    hall.marqueeModule.timePanel = null
  }

  onClear(): void {
    this.turnNum = 0
    this.jackGameList = []
    hall.marqueeModule.timePanel = null
    if (hall.marqueeModule.timePanel) {
      //Utility.cancelTimer(hall.marqueeModule.timePanel)
    }
    hall.marqueeModule.timePanel = null
  }
  onLoad(): void {}
  onDestroy(): void {}

  onPreloadData(): void {}

  sendReqEmailCount() {}

  inits2c(): void {
    //    hall.s2c["onClientLuckySpinGetAck"] = function (msg: proto.ClientLuckySpinGetAck) {
    //             //  玩家ID(UserID)
    //             // 本周内总投注额(从周一0点开始统计)(Total_bets)
    //             // 当前时间(NowTime)
    //             // 重置时间(ResetTime)
    //             // 剩余抽奖次数(LeftSpinTimes)
    //             // 奖区信息数组(LuckySpinLevelInfos)
    //             // 转盘类型(1.青铜, 2.白银, 3.黄金, 4.铂金, 5.钻石, 6.超级)(SpinLevel)
    //             // 抽奖的投注额度限制条件(SpinBetsLimit)
    //             // 是否已抽奖(AlreadySpin)
    //             // 抽奖赠金(SpinPrize)
    //             // 抽奖格列表(SpinCells)
    //             hall.waterWheelModule.setInfo(msg)
    //             if (msg == null || msg.UserID != hall.userModule.userId) {
    //                 hall.waterWheelModule.setInfo(null)
    //             }
    //             hall.eventDispatcher.emit(hall.EventDefine.OnWaterWheelChange);
    //         };
  }

  marqueSwitch(type: boolean) {
    if (this.isStart == false && type == true) {
      //开始启动
      this.marqueStart()
    } else if (this.isStart == true && type == false) {
      //结束跑马灯
      if (hall.marqueeModule.timePanel) {
        // Utility.cancelTimer(hall.marqueeModule.timePanel)
      }
      hall.marqueeModule.timePanel = null
    }
    this.isStart = type
  }

  //启动跑马灯
  marqueStart(): void {
    if (hall.marqueeModule.timePanel == null) {
      const nextMarquee = function () {
        //发送下一条跑马灯信息
        hall.marqueeModule.turnNum =
          hall.marqueeModule.turnNum >= 99 ? 0 : hall.marqueeModule.turnNum + 1
        // hall.eventDispatcher.emit(hall.EventDefine.OnMarqueeInfo)
      }
      nextMarquee()
      // hall.marqueeModule.timePanel = Utility.scheduleRepeat(nextMarquee, 1.5)
    }
  }

  //模拟假信息
  initTurnList() {
    const name = this.generateGuestIds()

    const types = ['win', 'deposit', 'withdraw']

    // 定义各类型对应的金额池
    const depositAmounts = [1000, 2000, 5000, 10000, 20000]
    const withdrawAmounts = [1000, 2000, 5000, 10000]

    for (let i = 0; i < 100; i++) {
      const userNum = Math.floor(Math.random() * 10) + 1
      const uerdId = 'resources://' + userNum
      //let type = Math.floor(Math.random() * 3)

      // 定义三种类型的标识
      const typeIndex = Math.floor(Math.random() * types.length)
      const currentType = types[typeIndex]

      let moneyVal = 0
      let moneyStr = ''

      if (currentType === 'win') {
        // 中奖：1000 ~ 20000 随机，保留2位小数
        // Math.random() * (max - min) + min
        const randomFloat = Math.random() * (20000 - 1000) + 1000
        moneyVal = parseFloat(randomFloat.toFixed(2))
        moneyStr = 'Rs' + moneyVal.toFixed(2)
      } else if (currentType === 'deposit') {
        // 充值：从固定数组随机选
        const amount = depositAmounts[Math.floor(Math.random() * depositAmounts.length)] || 1000
        moneyVal = amount
        moneyStr = 'Rs' + amount.toFixed(2) // 格式化为 Rs1000.00 风格，保持统一
      } else if (currentType === 'withdraw') {
        // 提现：从固定数组随机选
        const amount = withdrawAmounts[Math.floor(Math.random() * withdrawAmounts.length)] || 1000
        moneyVal = amount
        moneyStr = 'Rs' + amount.toFixed(2)
      }

      const data = { nickname: name[i], money: moneyStr, uerdId: uerdId, type: typeIndex }
      this.turnList.push(data)
    }
    //this.turnList.sort(() => Math.random() - 0.5);
  }

  generateGuestIds(): string[] {
    const guestIds: string[] = []
    for (let i = 0; i < 100; i++) {
      // 生成0-9999的随机数
      const randomNum = Math.floor(Math.random() * 10000)
      // 转换为4位字符串，不足补零
      const numStr = randomNum.toString().padStart(4, '0')
      // 隐藏前两位
      const hiddenId = `Guest**${numStr.substring(2)}`
      guestIds.push(hiddenId)
    }
    return guestIds
  }

  maskUsername = (username: string) => {
    const guestPos = username.indexOf('Guest')
    if (guestPos === -1) return username
    return username.slice(0, guestPos + 5) + '**' + username.slice(guestPos + 7)
  }

  // getJackSubgameIDList() {
  //     //随机展示多少个游戏。
  //     if (this.jackGameList.length == 0) {
  //         let name = this.generateGuestIds()

  //         let hotList = hall.hallModule.getHotGameList()
  //         //let randomHotLIst = Math.floor(Math.random() * (12 - 6 + 1)) + 6;

  //         for (let i = 0; i < hotList.length; i++) {
  //             let randomNum = Math.random() * 20;
  //             let num = "Rs" + parseFloat(randomNum.toFixed(2))
  //             let userNum = Math.floor(Math.random() * 10) + 1;
  //             let uerdId = userNum
  //             let data = { name: name[i], money: num, uerdId: uerdId, id: hotList[i] }
  //             this.jackGameList.push(data)
  //         }

  //     }

  // }

  getJackSubgameIDList() {
    // 清空旧数据，确保每次调用重新生成
    if (this.jackGameList.length != 0) {
      return
    }
    this.jackGameList = []

    // 获取热门游戏列表 (假设 hall.hallModule.getHotGameList() 返回如 [123, 321, ...])
    const hotList = hall.hallModule.getHotGameList()

    // 如果 hotList 为空，防止报错，直接返回或做处理
    if (!hotList || hotList.length === 0) {
      console.warn('Hot game list is empty')
      return
    }

    // 定义三种类型的标识
    const types = ['win']

    // 定义各类型对应的金额池
    const depositAmounts = [1000, 2000, 5000, 10000, 20000]
    const withdrawAmounts = [1000, 2000, 5000, 10000]
    const name = this.generateGuestIds()

    // 循环生成 40 条数据
    for (let i = 0; i < 10; i++) {
      // 1. 随机选择类型 (0: win, 1: deposit, 2: withdraw)
      const typeIndex = Math.floor(Math.random() * types.length)
      const currentType = types[typeIndex]

      // 2. 根据类型生成金额 (money)
      let moneyVal = 0
      let moneyStr = ''

      if (currentType === 'win') {
        // 中奖：1000 ~ 20000 随机，保留2位小数
        // Math.random() * (max - min) + min
        const randomFloat = Math.random() * (20000 - 1000) + 1000
        moneyVal = parseFloat(randomFloat.toFixed(2))
        moneyStr = 'Rs' + moneyVal.toFixed(2)
      } else if (currentType === 'deposit') {
        // 充值：从固定数组随机选
        const amount = depositAmounts[Math.floor(Math.random() * depositAmounts.length)] || 1000
        moneyVal = amount
        moneyStr = 'Rs' + amount.toFixed(2) // 格式化为 Rs1000.00 风格，保持统一
      } else if (currentType === 'withdraw') {
        // 提现：从固定数组随机选
        const amount = withdrawAmounts[Math.floor(Math.random() * withdrawAmounts.length)] || 1000
        moneyVal = amount
        moneyStr = 'Rs' + amount.toFixed(2)
      }

      // 3. 生成其他字段
      // 假设 generateGuestIds() 每次调用返回一个名字字符串。
      // 如果它返回的是数组，请改为 let name = this.generateGuestIds()[i % length];

      // 随机用户ID: 1 ~ 10
      const userNum = Math.floor(Math.random() * 10) + 1

      // 随机游戏ID: 从 hotList 中随机取一个 (因为要生成40条，hotList可能不够长)
      const gameId = hotList[Math.floor(Math.random() * hotList.length)]

      // 4. 组装数据对象
      const data = {
        name: name[i],
        money: moneyStr, // 显示用的字符串，如 "Rs1234.56"
        uerdId: userNum, // 注意：原代码变量名拼写为 uerdId，此处保持一致
        id: gameId, // 游戏ID
        type: currentType, // 新增类型字段: 'win', 'deposit', 'withdraw'
        rawMoney: moneyVal, // (可选) 如果需要用于排序或计算的纯数字，可以加上这个字段
      }

      this.jackGameList.push(data)
    }
    setTimeout(() => {
      hall.eventDispatcher.emit(hall.EventDefine.onschelirJackList)
    }, 3000)

    // 如果需要打印查看结果，可以取消下面注释
    // console.log("Generated Jack List:", this.jackGameList);
  }

  // changeTurnList(msg) {//添加玩家奖励
  //     let nameData = this.maskUsername(hall.userModule.userName)
  //     let data = { nickname: nameData, type: msg.TurnID }
  //     this.turnList[0] = data;
  //     this.turnList.sort(() => Math.random() - 0.5);
  //     hall.eventDispatcher.emit(hall.EventDefine.TurnTableChangTipsChange);
  // }
}
